// extracted by mini-css-extract-plugin
export default {"wrapper":"Home_wrapper__8fcgw","title":"Home_title__5Y1uc"};